export const URL_COLLECTION = 'collection';
export const URL_COLLECTION_COMPLETE = 'complete';
export const URL_COLLECTION_SEARCH = 'search';
export const URL_COLLECTION_NEWLY_ADDED = 'newly-added';
export const URL_COLLECTION_BY_GENRE = 'by-genre';
